import { render } from "./FailurePage.vue?vue&type=template&id=266161d2&scoped=true"
import script from "./FailurePage.vue?vue&type=script&lang=js"
export * from "./FailurePage.vue?vue&type=script&lang=js"

import "./FailurePage.vue?vue&type=style&index=0&id=266161d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266161d2"]])

export default __exports__